<template>
  <div class="media-block" :class="[backgroundStyle, backgroundColor]" :style="backgroundImage">
    <div
      class="container"
      :class="{ 'pt-0': paddingModifications['pt-0'], 'pb-0': paddingModifications['pb-0'] }"
      data-aos="fade-in"
    >
      <div
        class="primary-image"
        v-if="
          firstOrDefault(model?.elements?.primaryImage?.value) ||
          firstOrDefault(model?.elements?.primaryMobileImage?.value)
        "
      >
        <div class="desktop">
          <NuxtImg :src="model?.elements?.primaryImage?.value?.[0]?.url" class="img-fluid" />
        </div>
        <div class="mobile">
          <template v-if="firstOrDefault(model?.elements?.primaryMobileImage?.value)">
            <NuxtImg
              v-for="img in (model?.elements?.primaryMobileImage?.value ?? [])"
              :src="img?.url"
              class="img-fluid"
            />
          </template>
          <template v-else>
            <NuxtImg :src="model?.elements?.primaryImage?.value?.[0]?.url" class="img-fluid" />
          </template>
        </div>
      </div>
      <div v-if="model.elements.iframe.value">
        <IFrame
          v-for="data in pageStore.getListAs<IframeModel>(model.elements.iframe.value)"
          :model="data"
        />
      </div>
      <div class="video" v-if="!isEmpty(model.elements.videoEmbed.value)">
        <div v-html="model.elements.videoEmbed.value"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onBeforeUnmount, ref } from 'vue'
import { contentTypes, type IframeModel, type MediaBlockModel } from '~/models'

const pageStore = usePageStore()
const props = defineProps<{ model: MediaBlockModel }>()
const type = contentTypes._media_block

const paddingModifications = getPaddingModifications(
  props.model.elements.paddingModificationsPaddingModifications
)

const backgroundStyle = computed(() => {
  switch (firstOrDefault(props?.model?.elements?.imageStyle?.value)?.codename) {
    case 'image_background':
      return 'bg-image'
    default:
      return ''
  }
})

const backgroundColor = computed(() => {
  switch (firstOrDefault(props?.model?.elements?.backgroundColor?.value)?.codename) {
    case type.elements.background_color.options.white.codename:
      return 'white'
    case type.elements.background_color.options.deep_sea.codename:
      return 'deep_sea'
    case type.elements.background_color.options.silver_lake.codename:
      return 'silver_lake'
    case type.elements.background_color.options.lapis.codename:
      return 'lapis'
    default:
      return ''
  }
})

// START: Background Image, toggle between desktop and mobile image on lg breakpoint
const backgroundImage = ref({})

const updateBackgroundImage = () => {
  if (typeof window !== 'undefined') {
    const desktopUrl = props.model.elements.backgroundImage.value[0]?.url
    const mobileUrl = props.model.elements.mobileBackgroundImage.value[0]?.url
    const imageUrl =
      mobileUrl && window.matchMedia('(max-width: 960px)').matches ? mobileUrl : desktopUrl
    backgroundImage.value = imageUrl ? { 'background-image': `url(${imageUrl})` } : {}
  }
}

onMounted(() => {
  updateBackgroundImage()
  window.addEventListener('resize', updateBackgroundImage)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateBackgroundImage)
})
// END: Background Image
</script>
